import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Alert, ErrorScreen } from 'components/common';
import { useConfiguration } from 'components/hooks';
import withRequest from 'hoc/withRequest';
import { ConfigurationSchema } from 'schemas';
import { CircularProgress, Backdrop } from '@mui/material';
import ConfigurationFormDumb from './ConfigurationFormDumb';


const ConfigurationEditSmart = (props) => {
  const { cleanUpMessage, error, success, putConfiguration, getConfiguration, data, isLoaded } = useConfiguration();

  const [defaultValues, setDefaultValues] = useState({
    ansibleRunerPath: '',
    ansibleConfig: '',
    mailHost: '',
    mailPort: 0,
    mailSecure: false,
    mailUser: '',
    mailPass: '',
    mailRejectUnauthorized: false,
    mailFrom: '',
    inventory_path: '',
    threads:'0',
    macros_playbook_path: '',
    macros_playbook: '',
    macros_config_path: '',
  });

  useEffect(() => {
    if (success.get) {
      handleData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.get]);

  useLayoutEffect(() => {
    getConfiguration();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEdit = (data) => {
    const config = new ConfigurationSchema();
    config.setValues(data);
    putConfiguration({ body: config.getValues() });
  };

  function handleData() {
    const info = {
      ansibleRunerPath: data.ansible_runer_path,
      ansibleConfig: data.ansible_config,
      mailHost: data.mail_host,
      mailPort: data.mail_port,
      mailSecure: data.mail_secure,
      mailUser: data.mail_user,
      mailPass: data.mail_pass,
      mailRejectUnauthorized: data.mail_rejectUnauthorized,
      mailFrom: data.mail_from,
      threads: data.threads,
      inventory_path: data.inventory_path,
      macros_playbook_path: data.macros_playbook_path,
      macros_playbook: data.macros_playbook,
      macros_config_path: data.macros_config_path
    };
    setDefaultValues(info);
  };

  const alerts = [
    {
      severity: 'info',
      open: success.put,
      message: 'configuration.components.alert.putSuccess',
    },
    {
      severity: 'error',
      open: error.put,
      message: 'configuration.components.alert.error',
    }
  ];

  return (
    <>
      { error.get ?
        (
          <ErrorScreen />
        ): isLoaded.get ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ): (data) ?
        (
          <ConfigurationFormDumb
            defaultValues={defaultValues}
            handleOnSubmit={handleEdit}
            isEdit={true}
          />
        )
        :(
          <ErrorScreen />
        )
      }
      { alerts.map((alert, index) => (
        <Alert
          key={index}
          severity={alert.severity}
          handleClose={() => cleanUpMessage()}
          open={alert.open}
          message={alert.message}
        />
      ))}
    </>
  );
};

export default withRequest(ConfigurationEditSmart);
